/*  a thin wrap around process.env variables because of this:
    https://github.com/webpack/webpack/issues/1977
    and for decoupling the app files from node process.env.
 */

export let NODE_ENV = process.env.NODE_ENV;
export let DEBUG_LOCALE = process.env.DEBUG_LOCALE;
